import React from 'react';
import { IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Service } from '../../../../types/Service.types';
import DialogAddServiceToAgent from '../../../AgentEditPage/components/AgentServicesTable/components/DialogAddServiceToAgent';

interface Props {
  onExecute: () => void;
  /** Marker der Nutzungserfassung (RITA-1504); der Wrapper bildet ihn aus dem Tabellennamen. */
  usageKey?: string;
  forServicesById?: { tableName: string; services: Service[]; agent_id: string | undefined; refresh: () => void };
}

function AddButton({ onExecute, usageKey, forServicesById }: Props) {
  switch (forServicesById?.tableName) {
    case 'AgentServiceTable':
      return (
        <div style={{ textAlign: 'center' }}>
          <DialogAddServiceToAgent
            allServices={forServicesById?.services}
            agent_id={forServicesById?.agent_id}
            refreshServicesById={forServicesById?.refresh}
          />
        </div>
      );
    default:
      return (
        <IconButton onClick={onExecute} data-usage={usageKey}>
          <AddIcon />
        </IconButton>
      );
  }
}

export default AddButton;
